import stylesheet from './assets/removeScollbar.css';

let initedOnce = false;
export function initGlobalStylesheet() {
  if (initedOnce) return;
  const cssLink = document.createElement('style');
  cssLink.innerText = stylesheet;
  document.head.appendChild(cssLink);
  initedOnce = true;
}
